import { Link, Outlet } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import { useAuth } from '../context/AuthContext'

export default function SalesHubLayout() {
  const { user } = useAuth()
  const initials = user?.email?.slice(0, 2).toUpperCase() ?? '??'

  return (
    <div className="h-screen bg-zinc-950 flex flex-col overflow-hidden">

      {/* Top bar */}
      <header className="sticky top-0 z-30 h-14 bg-zinc-900 border-b border-zinc-800 flex items-center justify-between px-6 flex-shrink-0">
        <div className="flex items-center gap-5">
          <Link
            to="/"
            className="flex items-center gap-1 text-xs text-zinc-500 hover:text-zinc-300 transition-colors"
          >
            <ChevronLeft size={14} />
            Admin
          </Link>
          <div className="w-px h-4 bg-zinc-700" />
          <span className="font-mono text-xs tracking-[0.3em] text-yellow-400">SALES HUB</span>
        </div>

        <div className="w-7 h-7 rounded-full bg-zinc-700 flex items-center justify-center text-[10px] font-medium text-zinc-300 select-none">
          {initials}
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  )
}
